import { Button, Link, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    zIndex: 100,
    marginTop: 70,
  },
  image: {
    alignSelf: 'center',
    marginLeft: '-15px',
  },
  header: {
    color: 'rgb(32,33,36)',
    maxWidth: 500,
    fontWeight: 500,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      lineHeight: '40px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 38,
      letterSpacing: -0.43,
      lineHeight: '52px',
    },
  },
  info: {
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    alignSelf: 'center',
    maxWidth: 670,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 30,
    },
  },
}));

export const ContactSales = () => {
  const { image, root, header, info } = useStyles();
  return (
    <div className={root}>
      <h2 className={header}>Go further with</h2>
      <img
        className={image}
        width="200"
        src={process.env.PUBLIC_URL + '/images/google_cloud_logo.png'}
        alt="google cloud logo"
      />
      <p className={info}>
        Want to accelerate your data intelligence journey, faster? Get in touch
        to see how Google Cloud can help you harness the power of data cloud.
      </p>
      <Link
        underline="none"
        target="blank"
        href={`https://cloud.google.com/contact?utm_source=cgc-in-product&utm_medium=et&utm_campaign=FY21-Q2-northam-NA1007-other-dl-data_transformation_p2_master&utm_content=data-transformation-assessment`}
      >
        <Button color="primary" variant="contained">
          Contact sales
        </Button>
      </Link>
    </div>
  );
};
